import { LOCAL_ORIGIN_CHECK } from './util/localTransportOrigin';

// Load the application only after its origin has been checked. Static imports in the app can access persisted state.
if (LOCAL_ORIGIN_CHECK) {
  void LOCAL_ORIGIN_CHECK.then(() => import('./app'));
} else {
  void import('./app');
}
